import L10n from '@l10n/l10n.js'
import MessageBundle from '@l10n/message-bundle.js'

export { L10n, MessageBundle }